import type { DeepPartial } from '@luna/utils-ts';

import type { Misc } from '../../types/Misc';

export const miscHUFeatureConfig: DeepPartial<Misc> = {
    addTokenToDownloadPayload: true,
    externalPlatformTargetClientId: 'gbroker',
};
